import videojs from 'video.js';
import { createFlow, fetchMiddleware, reduceMiddleware } from 'lamnr';

import 'video.js/dist/video-js.css';
import './styles/video-js-theme.css'
import './components/CustomBigPlayButton/CustomBigPlayButton';
import './components/CustomLoadingSpinner/CustomLoadingSpinner';
import './components/SkipForward/SkipForward';
import './components/SkipBackward/SkipBackward';

import { authenticatePasswordFlow, saveToLibraryFlow } from './flows/authenticatePassword.flow.js';
import { displayElementMiddleware } from './middleware/displayElement.middleware.js';
import { simpleDataStoreMiddleware } from './middleware/simpleDataStore.middleware.js';
import { get } from './functions/get.js';

const playerOptions = {
  controls: true,
  fill: true,
  preload: 'auto',
  autoplay: false,
  playbackRates: [0.5, 1, 1.5, 2, 4],
};

const downloadButton = document.querySelector('#submit');
const passwordButton = document.querySelector('#submit');
const passwordInput = document.querySelector('#password');
const saveToLibraryButton1 = document.querySelector('#saveToLibraryButton1');
const saveToLibraryButton2 = document.querySelector('#saveToLibraryButton2');
const freeTrialButton1 = document.querySelector('#freeTrial1');
const freeTrialButton2 = document.querySelector('#freeTrial2');
const player = videojs(document.querySelector('video'), playerOptions);

// Remove default BigPlayButton
player.removeChild(player.bigPlayButton);
player.removeChild(player.loadingSpinner);

// Add new components to the player DOM
player.addChild('CustomBigPlayButton');
player.addChild('CustomLoadingSpinner');
player.getChild('controlBar').addChild('SkipBackward', {}, 0);
player.getChild('controlBar').addChild('SkipForward', {}, 2);
player.volume(0.2);

// Data layer
const middleware = [fetchMiddleware({ get }), reduceMiddleware, displayElementMiddleware, simpleDataStoreMiddleware];
export const flowController = createFlow({ middleware });

// Submit button event
passwordButton.addEventListener('click', (event) => {
  event.preventDefault();
  const password = passwordInput.value;
  flowController.pushFlow({ flow: authenticatePasswordFlow, args: { password, player } });
});

// Allow submit on enter
passwordInput.addEventListener('keyup', function (event) {
  // Number 13 is the "Enter" key on the keyboard
  if (event.keyCode === 13) {
    event.preventDefault();
    passwordButton.click();
  }
});

downloadButton.addEventListener('click', () => {
  console.log('DOWNLOAD BTN');
});

function saveToLibrary() {
  flowController.pushFlow({ flow: saveToLibraryFlow, args: { env: process.env.ENVIRONMENT }});
}

saveToLibraryButton1.addEventListener('click', saveToLibrary);
saveToLibraryButton2.addEventListener('click', saveToLibrary);

function openFreeTrial() {
  window.open('https://app.coach-logic.com/s/register')
}

freeTrialButton1.addEventListener('click', openFreeTrial);
freeTrialButton2.addEventListener('click', openFreeTrial);